import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PF2MSearchSelectOutlined from '../PF2MSearchSelectOutlined';
import styles from './styles';

const PF2MSelectOption = ({
  value,
  options,
  disabled,
  onChange,
  classes,
  error = false,
  placeholder = 'Selecionar',
  description,
  helperText,
  descriptionClassName,
  boxDescriptionClassName,
}) => (
  <Box className={classNames(classes.boxForm, boxDescriptionClassName)}>
    {description && (
      <Typography className={classNames(classes.formDescription, descriptionClassName)}>
        {description}
      </Typography>
    )}
    <PF2MSearchSelectOutlined
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      className={classes.selectWrapper}
      textFieldProps={{
        error,
        helperText: error ? helperText : '',
      }}
    >
      {options}
    </PF2MSearchSelectOutlined>
  </Box>
);

PF2MSelectOption.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  description: PropTypes.string,
  descriptionClassName: PropTypes.string,
  boxDescriptionClassName: PropTypes.string,
};

PF2MSelectOption.defaultProps = {
  classes: {},
  value: {},
  onChange: () => {},
  disabled: false,
  options: [],
  error: false,
  placeholder: 'Selecionar',
  helperText: 'Campo obrigatório',
  description: '',
  descriptionClassName: '',
  boxDescriptionClassName: '',
};

export default withStyles(styles)(PF2MSelectOption);
